// client/src/routes/link/meter.$token.tsx — SCR-LINK-001 „Trimitere index (link)" ·
// PORTAL-002 phase 3 (04 §6.7, §8.16).
//
// ── the two absences phase 1 declared, still true and still load-bearing ────────────────────
//   1. NO `beforeLoad`. §6.7's flow has no login, and a guard here — even one that only *reads*
//      the session — would fire `ensureSession()`, which presents the refresh cookie to
//      `/auth/refresh` on a page whose whole premise is that the visitor has no account.
//      `link-flow-shell.test.tsx` asserts that call never happens.
//   2. THE TOKEN IS NEVER RENDERED. It is read now — phase 3 is the phase that sends it
//      somewhere — but it goes into the path of an anonymous request and into nothing else. A
//      single-purpose credential is not display copy, and `link-flows.test.tsx` re-asserts it
//      over the filled-in page.
//
// A THIRD absence is phase 3's own: this route does NOT use the configured client. Every call it
// makes travels `features/links/anonymous-client.ts`, which sends no bearer, presents no cookie,
// refreshes nothing and never navigates to `/login` on a 401 — see that file for the four
// specific ways the shared instance would break this page (D-1185).
//
// 04 §9.2's inventory also lists a `link/route.tsx` layout „LinkFlowShell (§6.7), NO auth guard".
// There is none, and there cannot usefully be one: the shell's only datum is the property
// address, which arrives with the TOKEN, and `$token` is a parameter of these leaf routes rather
// than of any layout above them. The shell is rendered by `LinkPage` instead — once, for both
// pages — which is the same „defined in one place" the layout was for. D-1189.

import { createFileRoute } from '@tanstack/react-router';

import { LinkPage } from '@/features/links/LinkPage';
import { MeterLinkForm } from '@/features/links/MeterLinkForm';

export const Route = createFileRoute('/link/meter/$token')({
  component: MeterLinkScreen,
});

function MeterLinkScreen() {
  const { token } = Route.useParams();

  return (
    <LinkPage token={token} expects="METER_READING">
      {(context) => <MeterLinkForm token={token} context={context} />}
    </LinkPage>
  );
}
